import { useEffect } from 'react';
import { useSingleton } from '@okee-uikit/react-hooks';
import { Popper, popperCore } from '../../../models/popper';
export function usePopper() {
  var popper = useSingleton(function () {
    return new Popper();
  });
  useEffect(function () {
    popperCore.initPopperCoreEvent();
    return function () {
      return popper.dispose();
    };
  }, []);
  return {
    popper: popper
  };
}